import type { LocationType } from '@/venue/venue';
import { formatLocation, formatParty } from '@/venue/venue';
import { Icon } from './Icon';

/** "Table 12" / "Seat B12", with an optional "Rahul · 3 guests". No venue branching here: venue.ts decides. */
export function LocationChip({
  type,
  label,
  guestName,
  guestCount,
}: {
  type: LocationType;
  label: string;
  guestName?: string;
  guestCount?: number | null;
}) {
  return (
    <p className="inline-flex min-w-0 items-center gap-1.5 rounded-full bg-primary-soft py-1.5 pr-3 pl-2.5 text-sm font-semibold text-primary">
      <Icon name="pin" size={16} />
      <span className="whitespace-nowrap">{formatLocation(type, label)}</span>
      {guestName && (
        <span className="truncate font-normal text-primary/80">
          {formatParty(type, guestName, guestCount)}
        </span>
      )}
    </p>
  );
}
